<template>
  <div class="work-flx">
    <div class="work-flx-type">
      <p class="work-type-num purple">
        <span class="label">应签到</span>
        <span class="value">{{ data.numInfo.signNum | formatNumber }}</span>
      </p>
      <p class="work-type-num blue">
        <span class="label">实签到</span>
        <span class="value">{{ data.numInfo.realSignNum | formatNumber }}</span>
      </p>
      <p class="work-type-num yellow">
        <span class="label">未签到</span>
        <span class="value">{{ data.numInfo.notSignNum | formatNumber }}</span>
      </p>
      <p class="work-type-num red">
        <span class="label">请假</span>
        <span class="value">{{ data.numInfo.leaveNum | formatNumber }}</span>
      </p>
    </div>
    <div
      class="work-flx-school"
      :style="{ position: !data.schList.length ? 'relative' : '' }"
    >
      <template v-if="data.schList.length">
        <div
          class="work-school-num"
          v-for="(elx, idx) in data.schList"
          :key="idx"
        >
          <Poptip
            trigger="hover"
            :title="elx.date"
            :content="`签到人数：${elx.schoolSignNum}`"
          >
            <label>{{ elx.schoolName }}</label>
            <Progress
              :percent="
                Math.round((elx.schoolSignNum / elx.schoolTotalNum) * 100)
              "
            />
          </Poptip>
        </div>
      </template>
      <template v-else>
        <emptyTip />
      </template>
    </div>
  </div>
</template>

<script>
import emptyTip from "./empty.vue";
export default {
  props: {
    data: {
      type: Object,
      default: () => ({
        list: [],
        colSpan: 24
      })
    }
  },
  components: {
    emptyTip
  }
};
</script>

<style lang="scss" scoped>
.work-flx {
  width: 100%;
  padding-bottom: 30px;
  display: flex;
  &-type {
    padding-right: 30px;
    .work-type-num {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      margin-bottom: 20px;
      width: 390px;
      height: 76px;
      background: #efecfd;
      border-radius: 4px;
      .label {
        font-size: 18px;
        font-weight: 600;
        color: #444444;
      }
      .value {
        font-size: 24px;
        font-weight: 600;
        color: #444444;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    .purple {
      background: #efecfd;
    }
    .blue {
      background: #e8f3fe;
    }
    .yellow {
      background: #fdf5e5;
    }
    .red {
      background: #ffebeb;
    }
  }
  &-school {
    // position: relative;
    width: calc(100% - 420px);
    height: 364px;
    overflow: auto;
    padding-left: 30px;
    border-left: 1px solid #eeeeee;
    .work-school-num {
      width: 100%;
      display: flex;
      // margin-bottom: 19px;
      line-height: 33px;
      label {
        display: inline-block;
        width: 126px;
        margin-right: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      /deep/.ivu-progress {
        width: calc(100% - 136px);
      }
      /deep/.ivu-poptip {
        display: flex;
        width: 100%;
        &-rel {
          width: inherit;
          display: flex;
        }
        .ivu-progress {
          display: flex;
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
